import React, { memo, useMemo } from 'react'
import { useWatch } from 'react-hook-form'
import compact from 'lodash/compact'
import { FormHelperText } from 'transfix-ui/components/FormHelperText'
import makeStyles from 'transfix-ui/core/styles/makeStyles'
import { brandColors } from 'transfix-ui/theme/colors'
import { ILocationInput } from 'types/graphqlTypes'
import { useCreateShipmentFormContext } from 'apps/marketplace/pages/create-shipment/context'
import { TStopSchema } from 'apps/marketplace/pages/create-shipment/schema/ShipmentSchema/StopSchema'
import { getLocationInput } from 'apps/marketplace/pages/create-shipment/utils'
import { useCalculatedMilesQuery } from './graphql/CalculatedMiles'

export interface ICalculatedMilesWarningProps {}

const useWarningStyles = makeStyles(() => ({
  warning: {
    color: brandColors.warning,
    display: 'block',
  },
}))

const CalculatedMilesWarning = memo<ICalculatedMilesWarningProps>(() => {
  const classes = useWarningStyles()

  const { control } = useCreateShipmentFormContext()
  const stops = useWatch<TStopSchema[]>({ control, name: 'shipment.stops', defaultValue: [] })

  const facilityAddresses: ILocationInput[] = useMemo(() => getLocationInput(stops), [stops])

  // query is not called until at least 2 facilities are selected
  const { data, loading } = useCalculatedMilesQuery({
    variables: { stops: facilityAddresses },
    skip: compact(facilityAddresses).length < 2,
  })
  const { getCalculatedMiles: miles = 0 } = data || {}

  return (
    <>
      {facilityAddresses.length >= 2 && !loading && miles > 0 && (
        <FormHelperText className={classes.warning} data-test='calculated-miles'>
          Calculated Miles: {miles}
        </FormHelperText>
      )}
    </>
  )
})

export default CalculatedMilesWarning
